import { NotationModalComponent } from "./notation-modal/notation-modal.component";
import { NgbdModalConfirm } from "./../../services/modal-confirm";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ParametreNotation } from "./../../models/ParametreNotation";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-parametre-notation",
  templateUrl: "./parametre-notation.component.html",
  styleUrls: ["./parametre-notation.component.scss"],
})
export class ParametreNotationComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ParametreNotation>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeRule",
    "codeNotation",
    "libelleNotation",
    "codeSegmentPrudentiel",
    "isActive",
    "ponderation",
    "actions",
  ];
  data: ParametreNotation[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getParametreNotations();
  }

  getParametreNotations() {
    this.shared.getParametreNotations().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //row in modal popup
  EditerParametreNotation(row, activite) {
    const modalRef = this.modalService.open(NotationModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-app-old-modal-class",
    });
    modalRef.componentInstance.parametreNotation = row;
    modalRef.componentInstance.title = "Mise à jour de paramètre notation";
    if (activite == "add") {
      modalRef.componentInstance.title = "Ajout de paramètre notation";
    }

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getParametreNotations();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  //delete specific import
  SupprimerParametreNotation(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.codeSegmentPrudentiel;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer ce paramètre";
    modalConfirmRef.componentInstance.description =
      '<p>Toutes les informations de ce paramètre seront définitivement supprimées. <span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this.shared.SupprimerParametreNotation(row.id).subscribe(
          (data) => {
            console.log(data);
            this.getParametreNotations();
          },
          (error) => {
            this.isLoadingResults = false;
          },
          () => {
            this.isLoadingResults = false;
          }
        );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }
}
